export function getCompanyLogoURL(logos: { [key: string]: string }) {
  if (!logos) return '';
  return logos?.svg || logos?.png || logos?.jpg || logos?.jpeg;
}
